import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

/**
 * Phosphor "SmileyXEyes" — the error page's glyph, on the same 24 grid and 1.125 stroke as
 * `LockKeyIcon`. FPL has no equivalent, so it stays local and is themed via the FPL color var.
 */
const SmileyXEyesIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.125" />
      <path
        d="M6.75 9L9.75 12M9.75 9L6.75 12"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 9L17.25 12M17.25 9L14.25 12"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="16.875" r="0.9375" fill="currentColor" />
    </svg>
  );
};

export const SmileyXEyesIcon = fplIcon(SmileyXEyesIconLocal);
